import {
  Button,
  Typography,
  Input,
  DatePicker,
  Form,
  Card,
  Row,
  Col,
  Space,
  Select,
} from 'antd';
import React, { useCallback, useState, useRef } from 'react';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons';
import {
  DataGridPlus,
  SectionWrapper,
  HeaderTitle,
  FormLabel,
  // message,
  ColumnDataType,
  CopySpan,
  TablesFilter,
} from 'components/common';
import {
  getAuditBatchHistory,
  getAuditBatchHistorySync,
} from 'services/audits';
import moment from 'moment';
import {
  // getWarehouseIdFromCache,
  convertToUtcTime,
  trimValues,
} from 'utils';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { userProfiles } from 'utils/auth';

const { Title } = Typography;
const { RangePicker } = DatePicker;

const SYNC_STATUS_MAP = {
  '0': 'Not sync',
  '1': 'Success',
  '2': 'Failed',
  '3': 'Wait for response'
}

export default function LocationReport(): JSX.Element {
  const [history, setHistory] = useState<any[]>([]);
  const [syncHistory, setSyncHistory] = useState<any[]>([]);
  const [loading1, setLoading1] = useState<boolean>(false);
  const [loading2, setLoading2] = useState<boolean>(false);
  const [paramLimit, setParamLimit] = React.useState<number>(10);
  const [paramSkip, setParamSkip] = React.useState(0);
  const [paramLimit1, setParamLimit1] = React.useState<number>(10);
  const [paramSkip1, setParamSkip1] = React.useState(0);
  const [total, setTotal] = useState<number>(0);
  const [total1, setTotal1] = useState<number>(0);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [filteredSyncData, setFilteredSyncData] = useState<any[]>([]);
  const sortString = useRef('CreateDate desc');
  const sortString1 = useRef('CreateDate desc');
  const warehouses = useSelector((state: RootState) => {
    return state.admin.warehouses;
  }, shallowEqual);

  const [form] = Form.useForm();

  const enableLOT = userProfiles.getProfileSettingValue('EnableLOT') === '1';
  const enableUOM = userProfiles.getProfileSettingValue("EnableUOM") === '1';

  const columns = [
    {
      header: 'SKU',
      name: 'sku',
      minWidth: 220,
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'LOT#',
      name: 'lotNumber',
      userSelect: true,
      defaultFlex: 1,
      visible: enableLOT
    },
    {
      header: 'UOM',
      name: 'uom',
      userSelect: true,
      defaultFlex: 1,
      visible: enableUOM,
    },
    {
      header: 'Rate',
      name: 'uomRate',
      userSelect: true,
      defaultFlex: 1,
      visible: enableUOM,
    },
    {
      header: 'Base Qty',
      name: 'uomBaseQty',
      userSelect: true,
      defaultFlex: 1,
      visible: enableUOM,
    },
    {
      header: 'Transaction ID',
      name: 'auditTransactionId',
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'Location',
      name: 'locationCode',
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'Adjust Qty',
      name: 'adjustQty',
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'ERP Sync Status',
      name: 'syncStatus',
      userSelect: true,
      defaultFlex: 1,
      renderEnum: SYNC_STATUS_MAP,
      render: (row: any) => {
        const { data } = row;
        return (
          <CopySpan
            inGrid
            // @ts-ignore
            value={SYNC_STATUS_MAP[data.syncStatus]}
          />
        )
      }
    },
    {
      header: 'Close Date',
      name: 'createDate',
      userSelect: true,
      dataType: ColumnDataType.DATE,
      defaultFlex: 1,
    },
    {
      header: 'Close By',
      name: 'createBy',
      userSelect: true,
      defaultFlex: 1,
    },
    {
      header: 'Batch Number',
      name: 'auditTransactionId',
      userSelect: true,
      defaultFlex: 1,
    }
  ];

  const syncedColumns = [
    ...columns,
    {
      header: 'Sync Date',
      name: 'updateDate',
      userSelect: true,
      dataType: ColumnDataType.DATE,
      defaultFlex: 1,
    },
  ];

  const getHistory = useCallback(
    async (skip: number, top: number) => {
      // const warehouseId = getWarehouseIdFromCache(
      //   Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
      // );
      // if (!warehouseId) {
      //   return message.warning({ content: 'Not found default warehouse' });
      // }
      const params = form.getFieldsValue();
      try {
        setLoading1(true);
        const res = await getAuditBatchHistory(params.warehouse, {
          $skip: skip,
          $top: top,
          $sortBy: sortString.current,
          sku: params.sku ? params.sku : undefined,
          startDate: params.closeTime
            ? convertToUtcTime(params.closeTime[0].format())
            : undefined,
          endDate: params.closeTime
            ? convertToUtcTime(params.closeTime[1].format())
            : undefined,
        });
        setLoading1(false);
        if (res.isSuccess) {
          setHistory(res.data.data);
          setTotal(res.data.count);
        }
      } catch (error) {
        setLoading1(false);
      }
    },
    [form]
  );

  const getHistorySync = useCallback(
    async (skip: number, top: number) => {
      // const warehouseId = getWarehouseIdFromCache(
      //   Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
      // );
      // if (!warehouseId) {
      //   return message.warning({ content: 'Not found default warehouse' });
      // }
      const params = form.getFieldsValue();
      try {
        setLoading2(true);
        const res = await getAuditBatchHistorySync(
          params.warehouse,
          {
            $skip: skip,
            $top: top,
            $sortBy: sortString.current,
            sku: params.sku ? params.sku : undefined,
            startDate: params.closeTime
              ? convertToUtcTime(params.closeTime[0].format())
              : undefined,
            endDate: params.closeTime
              ? convertToUtcTime(params.closeTime[1].format())
              : undefined,
          }
        );
        setLoading2(false);
        if (res.isSuccess) {
          setSyncHistory(res.data.data);
          setTotal1(res.data.count);
        }
      } catch (error) {
        setLoading2(false);
      }
    },
    [form]
  );

  /**
   * handle search event
   */
  const handleSearch = useCallback(async () => {
    const params = await form.validateFields();
    if (params.errorFields) return;
    form.setFieldsValue({ ...trimValues(params) });
    // const warehouseId = getWarehouseIdFromCache(
    //   Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
    // );
    // if (!warehouseId) {
    //   return message.warning({ content: 'Not found default warehouse' });
    // }
    // setParamSkip(0);
    // setParamSkip1(0);
    // sortString.current = 'CreateDate desc';
    // sortString1.current = 'CreateDate desc';
    getHistory(paramSkip, paramLimit);
    getHistorySync(paramSkip1, paramLimit1);
  }, [
    form,
    paramSkip,
    paramLimit,
    paramSkip1,
    paramLimit1,
    getHistory,
    getHistorySync,
  ]);

  return (
    <>
      <HeaderTitle
        breadcrumb={[
          'Report',
          'Audit Batch Close History'
        ]}
      />

      <Card style={{ width: '100%', minWidth: 400 }}>
        <Form form={form}>
          <Row gutter={16}>
            <Col span={8}>
              <FormLabel>Warehouse</FormLabel>
              <Form.Item
                name="warehouse"
                rules={[{ required: true, message: 'Please select' }]}
              >
                {/* <SelectWarehouse /> */}
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                >
                  {warehouses.map((item) => {
                    return (
                      <Select.Option
                        key={item.warehouseId}
                        value={item.warehouseId}
                        label={item.code}
                      >
                        {item.code}
                      </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <FormLabel>SKU</FormLabel>
              <Form.Item name="sku">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <FormLabel>Close Date</FormLabel>
              <Form.Item
                name="closeTime"
                initialValue={[moment().add(-1, 'month').startOf('day'), moment().add(1, 'day').endOf('day')]}
              >
                <RangePicker
                  style={{ width: '100%' }}
                  allowClear={false}
                  format="MM/DD/YYYY"
                  ranges={{
                    Today: [moment().startOf('day'), moment().endOf('day')],
                    Yesterday: [
                      moment().add(-1, 'day').startOf('day'),
                      moment().add(-1, 'day').endOf('day'),
                    ],
                    '2 days ago': [
                      moment().add(-2, 'day').startOf('day'),
                      moment().endOf('day'),
                    ],
                    '3 days ago': [
                      moment().add(-3, 'day').startOf('day'),
                      moment().endOf('day'),
                    ],
                    'This Week': [
                      moment().startOf('week'),
                      moment().endOf('week'),
                    ],
                    'Last Week': [
                      moment().add(-1, 'week').startOf('week'),
                      moment().add(-1, 'week').endOf('week'),
                    ],
                    'This Month': [
                      moment().startOf('month'),
                      moment().endOf('month'),
                    ],
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row justify="center" align="middle" style={{ marginTop: 16 }}>
          <Space>
            <Button
              loading={loading1 && loading2}
              type="primary"
              onClick={handleSearch}
            >
              <SearchOutlined />
              <span>Search</span>
            </Button>
            <Button onClick={() => form.resetFields()}>
              <ClearOutlined />
              Reset
            </Button>
          </Space>
        </Row>
      </Card>

      <SectionWrapper style={{ marginTop: 16 }}>
        <Title level={5}>
          <Space size="middle">
            <span>
              Synced records
            </span>
            <TablesFilter
              dataSource={history}
              columns={columns}
              setFilteredData={setFilteredData}
            />
          </Space>
        </Title>
        <DataGridPlus
          style={{ minHeight: 500 }}
          showScrollButton
          autoWith={false}
          columns={columns}
          pageSizes={[10, 20, 50, 100]}
          count={total}
          pagination="remote"
          columnUserSelect={true}
          dataSource={filteredData}
          loading={loading1}
          idProperty="id"
          onSortInfoChange={async (v: any) => {
            if (v) {
              if (v.dir === 1) {
                sortString1.current = `${v.id} asc`;
                await getHistory(paramSkip, paramLimit);
              }
              if (v.dir === -1) {
                sortString1.current = `${v.id} desc`;
                await getHistory(paramSkip, paramLimit);
              }
            } else {
              sortString1.current = 'CreateDate desc';
              await getHistory(paramSkip, paramLimit);
            }
          }}
          showColumnMenuTool={false}
          onChange={(limit, skip) => {
            setParamLimit(limit);
            setParamSkip(skip);
            getHistory(skip, limit);
          }}
          {...({} as any)}
        />

        <Title style={{ marginTop: 10 }} level={5}>
          <Space size="middle">
            <span>
              Records waiting to be synced
            </span>
            <TablesFilter
              dataSource={syncHistory}
              columns={syncedColumns}
              setFilteredData={setFilteredSyncData}
            />
          </Space>
        </Title>
        <DataGridPlus
          style={{ minHeight: 500 }}
          columns={syncedColumns}
          showScrollButton
          pageSizes={[10, 20, 50, 100]}
          autoWith={false}
          count={total1}
          columnUserSelect={true}
          dataSource={filteredSyncData}
          loading={loading2}
          idProperty="id"
          pagination="remote"
          showColumnMenuTool={false}
          onChange={(limit, skip) => {
            setParamLimit1(limit);
            setParamSkip1(skip);
            getHistorySync(skip, limit);
          }}
          onSortInfoChange={async (v: any) => {
            if (v) {
              if (v.dir === 1) {
                sortString.current = `${v.id} asc`;
                await getHistorySync(paramSkip1, paramLimit1);
              }
              if (v.dir === -1) {
                sortString.current = `${v.id} desc`;
                await getHistorySync(paramSkip1, paramLimit1);
              }
            } else {
              sortString.current = 'CreateDate desc';
              await getHistorySync(paramSkip1, paramLimit1);
            }
          }}
          {...({} as any)}
        />
      </SectionWrapper>
    </>
  );
}
